import { render } from "./ScrollableMenu.vue?vue&type=template&id=61af8b37&scoped=true&ts=true"
import script from "./ScrollableMenu.vue?vue&type=script&lang=ts"
export * from "./ScrollableMenu.vue?vue&type=script&lang=ts"

import "./ScrollableMenu.vue?vue&type=style&index=0&id=61af8b37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61af8b37"]])

export default __exports__